import { render } from "./TermAndService.vue?vue&type=template&id=144bf1b3&scoped=true"
const script = {}

import "./TermAndService.vue?vue&type=style&index=0&id=144bf1b3&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-144bf1b3"]])

export default __exports__